export function classifyConnectFailure(err) {
  const name = err?.name || '';
  const msg = err?.message || '';
  if (name === 'NotFoundError' || /No port selected/i.test(msg)) return 'no-port';
  if (name === 'InvalidStateError' || /already open|in use|failed to open/i.test(msg)) return 'port-busy';
  if (/HELLO|handshake|Failed to connect after 3/i.test(msg)) return 'silent';
  if (/Stream closed|Not connected/i.test(msg)) return 'transient';
  return 'open-failed';
}
